export default __webpack_public_path__ + "static/article-renovation-checklist-a695a28ee5d7b9f1d23be8609b299793.jpg";